import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { compose, withProps } from 'recompose'

import styles from './Text.module.scss'

const defaultProps = {
  element: 'p',
  ellipsis: false,
  paragraph: false,
  size: 'm',
  weight: 'regular',
  upperspaced: false
}

const propTypes = {
  // add text-alignment
  align: PropTypes.oneOf([
    'left',
    'right',
    'center',
    'justify',
    'start',
    'end'
  ]),

  // render something other than a 'p' tag, such as an h1
  element: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),

  // truncate single-line overflowing text with ellipsis
  ellipsis: PropTypes.bool,

  // modify the font size
  size: PropTypes.oneOf([
    'tiny',
    'xxs',
    'xs',
    's',
    'm',
    'l',
    'xl',
    'xxl',
    'xxxl'
  ]),

  // modify the font weight
  weight: PropTypes.oneOf(['light', 'regular', 'semibold', 'bold']),

  // modify the color
  color: PropTypes.oneOf([
    'blue',
    'danger',
    'green',
    'heather',
    'metal',
    'negative',
    'orange',
    'pink',
    'positive',
    'quiet',
    'heather',
    'red',
    'success',
    'warning',
    'white',
    'inherit',
    'gray'
  ]),

  nowrap: PropTypes.bool,

  transform: PropTypes.oneOf(['capitalize', 'lowercase', 'uppercase']),

  paragraph: PropTypes.bool,

  upperspaced: PropTypes.bool
}

const Text = compose(
  withProps(
    ({
      align,
      className,
      color,
      element,
      ellipsis,
      paragraph,
      size,
      nowrap,
      transform,
      weight,
      upperspaced
    }) => {
      return {
        className: classnames(
          className,
          styles.text,
          ellipsis && styles.ellipsis,
          styles[`size-${size}`],
          styles[`weight-${weight}`],
          styles[`color-${color}`],
          styles[`align-${align}`],
          styles[`transform-${transform}`],
          nowrap && styles.nowrap,
          paragraph && styles.paragraph,
          upperspaced && styles.upperspaced
        )
      }
    }
  )
)(
  ({
    align, // ignore
    color, // ignore
    element: Element,
    ellipsis, // ignore
    paragraph, // ignore
    size, // ignore
    nowrap, // ignore
    weight, // ignore
    transform, // ignore
    upperspaced, // ignore
    ...restProps
  }) => <Element {...restProps} />
)

Text.defaultProps = defaultProps
Text.propTypes = propTypes

export default Text
